import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PricingService } from '../../_service/PricingService';
import { GlobalService } from '../../_service/GlobalService';
import { FormGroup } from '@angular/forms';
import { environment } from '../../_environments/environment';
import { Price } from '../../_model/pricing';
import { Subject, takeUntil } from 'rxjs';
import { Countrycode } from '../../_model/shared';
import { SubscriptionService } from '../../_service/SubscriptionService';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { AddressService } from '../../_service/AddressService';
import { Lifestyle } from '../../_model/recipe';
import { OverlayModule } from '@angular/cdk/overlay';

@Component({
    selector: 'app-subscriptionpricing',
    templateUrl: './subscriptionpricing.component.html',
    imports: [NgClass, TranslateModule, OverlayModule]
})
export class SubscriptionpricingComponent implements OnInit, OnDestroy {

  private _lifestyles: Lifestyle[] = []
  @Input() set lifestyles(value: Lifestyle[]){
    this._lifestyles = value;
    if(!this._selectedLifestyleId) return
    this._selectedLifestyle = this.lifestyles.find(l=> l.id == this._selectedLifestyleId);
  }
  
  get lifestyles(){return this._lifestyles}
  private _selectedLifestyleId: number| null = null;
  @Input() set selectedLifestyleId(value: number | null){
    this._selectedLifestyleId = value;
    this._selectedLifestyle = this.lifestyles.find(l=> l.id == value);
  }
  @Input() useRecipefirstStyle: boolean = false;

  @Output() selectedLifestyle: EventEmitter<Lifestyle> = new EventEmitter<Lifestyle>();

  @Output() portionprice: EventEmitter<number> = new EventEmitter<number>();
  @Output() discountedportionprice: EventEmitter<number> = new EventEmitter<number>();

  _selectedLifestyle: Lifestyle;

  recipeQuantities: number[] = environment.subscriptionRecipeChoices;
  personChoices: number[] = environment.subscriptionPersonChoices;

  showLifestyleOverlay = false;

  pricing: Price;

  pricingform = new FormGroup({
    countrycode: this._addressService.shippingAddressForm.get('countrycode'),
    defaultpersons: this._subscriptionService.flowdefaultpersons,
    defaultrecipes: this._subscriptionService.flowdefaultrecipes
  })

  constructor(
    private _pricingService: PricingService,
    private _globalService: GlobalService,
    private _subscriptionService: SubscriptionService,
    private _addressService: AddressService,
    public _translateService: TranslateService
  ) {
  }

  _destroy$ = new Subject<void>();

  ngOnInit() {

    this.pricingform.valueChanges.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.getRecipeprice();
    })

    this.pricingform.get('countrycode').valueChanges.pipe(takeUntil(this._destroy$)).subscribe(countrycode => {
      this.getSubscriptionpricing(countrycode)
    })

    this.getSubscriptionpricing(Countrycode[this._globalService.getPricecountry()]);

  }
  ngOnDestroy() {
    this._destroy$.next();
  }

  getSubscriptionpricing(countrycode: Countrycode) {
    this._pricingService.getRecipesubscriptionPricing(countrycode).subscribe(res => {
      this.pricing = res;
      this.getRecipeprice();
    })
    
  }

  setDefaultPersons(persons: number) {
    this.pricingform.get('defaultpersons').setValue(persons);
    this.pricingform.get('defaultpersons').markAsDirty();
  }
  setDefaultRecipes(recipes: number) {
    this.pricingform.get('defaultrecipes').setValue(recipes);
    this.pricingform.get('defaultrecipes').markAsDirty();
  }

  setLifestyle(lifestyle: Lifestyle) {
    this._selectedLifestyle = lifestyle
    this._selectedLifestyleId = lifestyle.id;

    this.selectedLifestyle.emit(lifestyle);

    this.showLifestyleOverlay = false;
  }

  toggleLifestyleOverlay() {
    this.showLifestyleOverlay = !this.showLifestyleOverlay;
  }

  getRecipeprice():void {
    if (!this.pricing) return null;
    const persons = this.pricingform.get('defaultpersons').value;
    const recipes = this.pricingform.get('defaultrecipes').value;
    const countrycode = this.pricingform.get('countrycode').value;

    const pricing = this._pricingService.getRecipeprice(countrycode, persons, recipes)

    if (!pricing) return;

    this.discountedportionprice.emit(pricing.discountedportionprice)
    this.portionprice.emit(pricing.portionprice)
      

    //let price = 0;
    //let discountedprice = 0;
    //switch (persons) {
    //  case 1:
    //    price = this.pricing.onepersonrecipeprice
    //    break;
    //  case 2:
    //    price = this.pricing.twopersonrecipeprice
    //    break;
    //  case 3:
    //    price = this.pricing.threepersonrecipeprice
    //    break;
    //  case 4:
    //    price = this.pricing.fourpersonrecipeprice
    //    break;
    //  default:
    //    price = 0;
    //}

    //if (recipes === 4) {
    //  discountedprice = price * (1 - (this.pricing.fourbagsdiscountpercentage / 100))
    //} else {
    //  discountedprice = price;
    //}

    //discountedprice = discountedprice * (1 + (this.pricing.vatlow / 100))
    //price = price * (1 + (this.pricing.vatlow / 100))

    //this.discountedportionprice.emit(discountedprice / persons)
    //this.portionprice.emit(price / persons)

  }




}



